import { useEffect, useState } from 'react'
import { Box, Card, CardBody, CardHeader, Heading, Skeleton, Text } from '@chakra-ui/react'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { DeviceHealthWidget } from '@/components/dashboard/DeviceHealthWidget'
import { useThemeColors } from '@/hooks/useThemeColors'
import { DeviceHealthService } from '@/lib/services/deviceHealthService'

export default function DeviceHealthPage() {
  const colors = useThemeColors()
  const [stats, setStats] = useState({ online: 0, idle: 0, offline: 0, total: 0 })
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    DeviceHealthService.getSummary()
      .then((data) => setStats({ online: data.online ?? 0, idle: data.idle ?? 0, offline: data.offline ?? 0, total: data.total ?? 0 }))
      .finally(() => setLoading(false))
  }, [])

  return (
    <AdminLayout>
      <Box p={4}>
        <Card>
          <CardHeader>
            <Heading size="md">Device Health</Heading>
            <Text fontSize="sm" color={colors.text}>Live mobile device connectivity overview</Text>
          </CardHeader>
          <CardBody>
            {loading ? <Skeleton height="120px" /> : (
              <DeviceHealthWidget
                online={stats.online}
                idle={stats.idle}
                offline={stats.offline}
                total={stats.total}
              />
            )}
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}
